import { useContext, useState } from "react";
import styled from "styled-components";

import AuthContext from "common/store/AuthContext";
import StatusContext from "common/store/StatusContext";

import { useTasksAndPrints } from "../hooks/useTasksAndPictures";
import { PrintPanelTemplate } from "./PrintPanelTemplate";
import { SelectDayRangeControl } from "../../../common/components/molecules/SelectDayRangeControl";
import { TasksByTaskType } from "../types/TasksByTaskType";
import { PrintTasksRequestInfo } from "../types/PrintTasksRequestInfo";
import { SelectTasksPanel } from "./organisms/SelectTasksPanel";

type Props = {
  title: string;
};

export const PrintTaskAndPicturesControl = ({ title }: Props) => {
  const { selectedPark } = useContext(AuthContext);
  const { getConductedTasks, printReport } = useTasksAndPrints();
  const [tasks, setTasks] = useState<TasksByTaskType[]>();
  const [period, setPeriod] = useState<{ from: Date; to: Date }>();

  const { isLoading, setIsLoading, setLoadingMessage, setErrorMessage } = useContext(StatusContext);

  const periodDecided = async (startDate: Date, endDate: Date) => {
    if (!selectedPark) return;
    setErrorMessage("");
    setIsLoading(true);
    setLoadingMessage("対象期間の作業を取得中");
    const { succeeded, msg, data } = await getConductedTasks(
      selectedPark.parkId,
      startDate,
      endDate
    );
    setIsLoading(false);
    setPeriod({ from: startDate, to: endDate });
    if (!succeeded) {
      setErrorMessage(msg);
    }

    if (data) {
      setTasks(data.sort((a, b) => (a.taskType.id < b.taskType.id ? -1 : 1)));
    } else {
      setTasks(undefined);
    }
  };

  const printRequested = async (targets: PrintTasksRequestInfo[]) => {
    if (!selectedPark || !period) return;
    setErrorMessage("");
    setIsLoading(true);
    setLoadingMessage(`帳票${title}を作成中...`);

    const { succeeded, msg } = await printReport(targets, period.from, period.to, title);
    setIsLoading(false);

    if (!succeeded) {
      setErrorMessage(msg);
    }
  };

  return (
    <SRootDiv>
      <PrintPanelTemplate>
        <SelectDayRangeControl
          disabled={isLoading}
          dateConfirmed={periodDecided}
          okTitle="期間確定"
        />
      </PrintPanelTemplate>
      {tasks && <SelectTasksPanel tasks={tasks} printRequested={printRequested} />}
    </SRootDiv>
  );
};

const SRootDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
`;
